// Product card size swatches: navigate on click without exposing crawlable <a href="?variant="> links (SEO).
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.size-item-link[data-variant-url]');
  if (!swatch) return;
  var url = swatch.getAttribute('data-variant-url');
  if (url) window.location.href = url;
});

// Pagination prev/next arrows: JS-driven navigation so crawlers don't see duplicate <a href> links (SEO link juice).
document.addEventListener('click', function (event) {
  var arrow = event.target.closest('[data-pagination-url]');
  if (!arrow) return;
  var url = arrow.getAttribute('data-pagination-url');
  if (url) window.location.href = url;
});
